import React                       from 'react';
import Spin                        from '@widesk-ui/components/Spin';
import type { UpgradePromptProps } from './UpgradePrompt';

// NOTE: chargé à la demande : la bulle lit `subscriptionStore`, qui importe déjà ce bundle, et un
// import statique bouclerait au démarrage.
const UpgradePrompt = React.lazy(() => import('./UpgradePrompt'));

export default function LazyUpgradePrompt(props: UpgradePromptProps) {
	return (
		<React.Suspense fallback={<Spin size="small" />}>
			<UpgradePrompt {...props} />
		</React.Suspense>
	);
}
